'use client'

import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Text from '@mui/material/Typography'
import { FC } from 'react'

import CTATile from '@/components/CTATile'

const CTATilesSection: FC = () => {
    const { mdScreen, smScreen } = useDevice()

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: smScreen ? 'flex-start' : 'center',
                gap: smScreen ? 3 : 9,
                flexDirection: 'column',
            }}
        >
            <Text
                variant={mdScreen ? 'h5' : 'h4'}
                sx={{
                    textAlign: smScreen ? 'left' : 'center',
                }}
            >
                Turn decarbonisation into a business performance driver
            </Text>
            <Box
                sx={{
                    display: 'flex',
                    gap: smScreen ? 3 : mdScreen ? 2 : 3,
                    flexDirection: smScreen ? 'column' : 'row',
                }}
            >
                <CTATile
                    backgroundImageUrl={'/images/CTA-tiles/enterprise-shippers-card.jpg'}
                    imageAlt={
                        'Aerial view of a logistics warehouse with a solar roof and trucks at the loading docks.'
                    }
                    description={'Shipment data collection and compliant CO₂ reporting.'}
                    button={{
                        label: 'For enterprise shippers',
                        href: '/gryn-for-shippers',
                    }}
                />
                <CTATile
                    backgroundImageUrl={'/images/CTA-tiles/embed-emission-calcs.png'}
                    imageAlt={'Aerial view of a container ship at sea.'}
                    description={'Win tenders with green shipping options and emissions reduction.'}
                    button={{
                        label: 'For logistics providers',
                        href: '/logistics',
                    }}
                />
            </Box>
        </Box>
    )
}

export default CTATilesSection
